import { render, staticRenderFns } from "./PagedListRiddlesAverage.vue?vue&type=template&id=b68ab202&"
import script from "./PagedListRiddlesAverage.vue?vue&type=script&lang=js&"
export * from "./PagedListRiddlesAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports